"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleModelDataFeatures = void 0;
const core_1 = require("@angular/core");
const config_service_1 = require("../../../../../shared/config/config.service");
let VehicleModelDataFeatures = class VehicleModelDataFeatures {
    constructor(configService) {
        this.configService = configService;
        this.activeSection = '';
        this.selectOptions = {};
        this.showSection = (sectionName) => {
            if (this.activeSection === sectionName) {
                this.activeSection = '';
                return;
            }
            this.activeSection = sectionName;
        };
        this.selectOptions = {
            speedControl: this.configService.getConstant(config_service_1.ConstantTypes.SPEED_CONTROL),
            climatization: this.configService.getConstant(config_service_1.ConstantTypes.CLIMATIZATION),
            radioTypes: this.configService.getConstant(config_service_1.ConstantTypes.RADIO_TYPES),
            daytimeRunningLights: this.configService.getConstant(config_service_1.ConstantTypes.DAYTIMERUNNING_LIGHTS),
            headlightTypes: this.configService.getConstant(config_service_1.ConstantTypes.HEADLIGHT_TYPES),
            bendingHeadlights: this.configService.getConstant(config_service_1.ConstantTypes.BENDING_HEADLIGHTS),
            airbags: this.configService.getConstant(config_service_1.ConstantTypes.AIRBAGS),
            trailerCoupling: this.configService.getConstant(config_service_1.ConstantTypes.TRAILER_COUPLING),
            breakdownKit: this.configService.getConstant(config_service_1.ConstantTypes.BREAKDOWN_KIT),
        };
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleModelDataFeatures.prototype, "modelData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleModelDataFeatures.prototype, "importResult", void 0);
VehicleModelDataFeatures = __decorate([
    (0, core_1.Component)({
        selector: 'model-data-features',
        templateUrl: require('./features.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _a : Object])
], VehicleModelDataFeatures);
exports.VehicleModelDataFeatures = VehicleModelDataFeatures;
